import React from "react";

const LeftArrowCarrausol = React.forwardRef(
  (
    { width = "24", height = "25", viewBox = "0 0 24 25", fill = "none", className, ...props },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 12.4628H5M5 12.4628L12 19.4628M5 12.4628L12 5.46283"
          stroke="#667085"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
);

export default LeftArrowCarrausol;
